<template>
    <li class="navigation-item text-md">
        <v-link :anchor="anchor" :handler="onClick">
            <slot></slot>
        </v-link>
    </li>
</template>

<script>
import VLink from '@/components/ui/VLink';
import {mapMutations} from 'vuex';
export default {
    
    name: "VNavigationItem",
    components: { 
        VLink,
    },
    props: {
        anchor: {
            type: String,
        },
        form: {
            type: String
        }
    },

    methods: {
        ...mapMutations('forms', {
            setActiveFrom : 'SET_ACTIVE_FORM'
        }),

        onClick: function() {
            if(!this.form) return;
            this.setActiveFrom({ form: this.form })
        }
    }
};
</script>


<style lang="scss" scoped>
@media (max-width: 375px) {
}

@media (max-width: 411px) {
}

@media (max-width: 768px) {

}
</style>


<style scoped>

.navigation-item {

    list-style: none;
    font-weight: 500;
    line-height: 50px;
}

</style>